import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { LifeStageDatePrecisionEnum } from "@/Common/Models/LifeStageDatePrecisionEnum";
import { LifeStageModeEnum } from "@/Patient/Models/LifeStageModeEnum";
import { LifeStageAgeMode } from "./LifeStageAgeMode";
import { LifeStageMode } from "./LifeStageMode";
import { LifeStageStartDateMode } from "./LifeStageStartDateMode";

interface ILifeStageRowProps {
    lifeStageMode: LifeStageModeEnum;
    lifeStageAvailableAgeAtOnsetUnits: FlatLookupView[];
    lifeStageAgeSelectedAgeAtOnsetUnit: string;
    lifeStageAgeAtOnset: number;
    lifeStageSelectedLifeStageLookupId: string;
    lifeStageAvailableLifeStages: FlatLookupView[];
    lifeStageDatePrecision: LifeStageDatePrecisionEnum;
    lifeStageDateTextboxValue: string;
    lifeStageStartDate: Date;
    lifeStageIsStartDateApprox: boolean;
    useThreeCols: boolean;
    onLifeStageChange: (value: string) => void;
    onLifeStageDateChange: (date: DateTimeWithPrecision, precision: LifeStageDatePrecisionEnum) => void;
    onLifeStageModeClick: (newMode: LifeStageModeEnum) => void;
    onLifeStageDateApproxChange: () => void;
    onLifeStageDateTodayClick: () => void;
    onLifeStageAgeChange: (value: string) => void;
    onLifeStageAgeUnitChange: (value: string) => void;
}

function LifeStageRow(props: ILifeStageRowProps): JSX.Element {
    if (props.lifeStageMode === LifeStageModeEnum.Age) {
        return (
            <LifeStageAgeMode
                lifeStageAgeSelectedAgeAtOnsetUnit={props.lifeStageAgeSelectedAgeAtOnsetUnit}
                lifeStageAvailableAgeAtOnsetUnits={props.lifeStageAvailableAgeAtOnsetUnits}
                lifeStageAgeAtOnset={props.lifeStageAgeAtOnset}
                useThreeCols={props.useThreeCols}
                onLifeStageModeClick={newMode => props.onLifeStageModeClick(newMode)}
                onLifeStageAgeChange={value => props.onLifeStageAgeChange(value)}
                onLifeStageAgeUnitChange={value => props.onLifeStageAgeUnitChange(value)}
            />
        );
    }
    else if (props.lifeStageMode === LifeStageModeEnum.LifeStage) {
        return (
            <LifeStageMode
                lifeStageSelectedLifeStageLookupId={props.lifeStageSelectedLifeStageLookupId}
                lifeStageAvailableLifeStages={props.lifeStageAvailableLifeStages}
                useThreeCols={props.useThreeCols}
                onLifeStageModeClick={newMode => props.onLifeStageModeClick(newMode)}
                onLifeStageChange={value => props.onLifeStageChange(value)}
            />
        );
    }

    return (
        <LifeStageStartDateMode
            lifeStageDatePrecision={props.lifeStageDatePrecision}
            lifeStageDateTextboxValue={props.lifeStageDateTextboxValue}
            lifeStageStartDate={props.lifeStageStartDate}
            lifeStageIsStartDateApprox={props.lifeStageIsStartDateApprox}
            useThreeCols={props.useThreeCols}
            onLifeStageDateChange={(date, precision) => props.onLifeStageDateChange(date, precision)}
            onLifeStageModeClick={newMode => props.onLifeStageModeClick(newMode)}
            onLifeStageDateApproxChange={() => props.onLifeStageDateApproxChange()}
            onLifeStageDateTodayClick={() => props.onLifeStageDateTodayClick()}
        />
    );
}

export { LifeStageRow };
